import { render, staticRenderFns } from "./WarningBlock.vue?vue&type=template&id=469d63ea&"
import script from "./WarningBlock.vue?vue&type=script&lang=js&"
export * from "./WarningBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports